export default __webpack_public_path__ + "static/media/MichaelJohnson.53626913.jpg";